module.exports = __webpack_public_path__ + "img/sample2.b6003cc3.jpg";